var _g, _rect, _g2, _rect2, _g3, _rect3, _g4, _rect4, _g5, _rect5, _rect6, _rect7, _rect8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTab3Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2614_1235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9906 17.998L20.6455 22.4976V24.8384H40.0003V22.4851L29.9906 17.998ZM38.71 23.5481H21.9358V23.3084L30.0101 19.4208L38.71 23.3208V23.5481ZM21.9358 33.8707H38.71V35.161H21.9358V33.8707ZM20.6455 36.1288H40.0003V37.4191H20.6455V36.1288ZM22.2584 26.1288H23.5487V32.5804H22.2584V26.1288ZM37.0971 26.1288H38.3874V32.5804H37.0971V26.1288ZM33.2262 26.1288H34.5165V32.5804H33.2262V26.1288ZM26.1294 26.1288H27.4197V32.5804H26.1294V26.1288ZM29.6778 26.1288H30.9681V32.5804H29.6778V26.1288Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.131,
    y: 46.131,
    width: 13.5449,
    height: 13.2223,
    rx: 6.61116,
    stroke: "white",
    strokeWidth: 0.648649
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2614_1235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9847 51.7685V55.0117M50.7955 51.7685V55.0117M49.8225 51.7685V55.0117M55.0117 51.7685V55.0117M49.6604 55.6604H56.1469M49.0117 56.4712H56.7955M52.9036 52.4171H52.5793C52.4933 52.4171 52.4108 52.4513 52.35 52.5121C52.2891 52.5729 52.255 52.6554 52.255 52.7414V52.8631C52.255 52.9332 52.2777 53.0015 52.3198 53.0577C52.3619 53.1138 52.4211 53.1548 52.4885 53.1744L53.3187 53.4167C53.3861 53.4363 53.4453 53.4773 53.4874 53.5334C53.5295 53.5896 53.5523 53.6579 53.5523 53.728V54.0387C53.5523 54.1248 53.5181 54.2073 53.4573 54.2681C53.3964 54.3289 53.314 54.3631 53.2279 54.3631H52.9036M52.9036 52.4171H53.2279C53.314 52.4171 53.3964 52.4513 53.4573 52.5121C53.5181 52.5729 53.5523 52.6554 53.5523 52.7414V52.9036M52.9036 52.4171V51.7685M52.9036 54.3631H52.5793C52.4933 54.3631 52.4108 54.3289 52.35 54.2681C52.2891 54.2073 52.255 54.1248 52.255 54.0387V53.8766M52.9036 54.3631V55.0117M56.6333 50.8766V51.1198H49.1739V50.8766C50.7955 50.309 51.7685 49.8225 52.8225 49.0117H52.9847C54.0387 49.8225 55.0117 50.309 56.6333 50.8766Z",
    stroke: "white",
    strokeWidth: 0.454054
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.324324,
    y: 46.131,
    width: 13.5449,
    height: 13.2223,
    rx: 6.61116,
    stroke: "white",
    strokeWidth: 0.648649
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2614_1235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1781 51.7685V55.0117M4.98886 51.7685V55.0117M4.01589 51.7685V55.0117M9.20508 51.7685V55.0117M3.85373 55.6604H10.3402M3.20508 56.4712H10.9889M7.09697 52.4171H6.77265C6.68663 52.4171 6.60414 52.4513 6.54331 52.5121C6.48249 52.5729 6.44832 52.6554 6.44832 52.7414V52.8631C6.44832 52.9332 6.47108 53.0015 6.51319 53.0577C6.55529 53.1138 6.61447 53.1548 6.68184 53.1744L7.51211 53.4167C7.57947 53.4363 7.63865 53.4773 7.68075 53.5334C7.72286 53.5896 7.74562 53.6579 7.74562 53.728V54.0387C7.74562 54.1248 7.71145 54.2073 7.65063 54.2681C7.5898 54.3289 7.50731 54.3631 7.42129 54.3631H7.09697M7.09697 52.4171H7.42129C7.50731 52.4171 7.5898 52.4513 7.65063 52.5121C7.71145 52.5729 7.74562 52.6554 7.74562 52.7414V52.9036M7.09697 52.4171V51.7685M7.09697 54.3631H6.77265C6.68663 54.3631 6.60414 54.3289 6.54331 54.2681C6.48249 54.2073 6.44832 54.1248 6.44832 54.0387V53.8766M7.09697 54.3631V55.0117M10.8267 50.8766V51.1198H3.36724V50.8766C4.98886 50.309 5.96184 49.8225 7.01589 49.0117H7.17805C8.23211 49.8225 9.20508 50.309 10.8267 50.8766Z",
    stroke: "white",
    strokeWidth: 0.454054
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46.131,
    y: 0.324324,
    width: 13.5449,
    height: 13.2223,
    rx: 6.61116,
    stroke: "white",
    strokeWidth: 0.648649
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2614_1235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9847 5.96183V9.20508M50.7955 5.96183V9.20508M49.8225 5.96183V9.20508M55.0117 5.96183V9.20508M49.6604 9.85373H56.1469M49.0117 10.6645H56.7955M52.9036 6.61048H52.5793C52.4933 6.61048 52.4108 6.64465 52.35 6.70548C52.2891 6.7663 52.255 6.84879 52.255 6.93481V7.05643C52.255 7.1266 52.2777 7.19488 52.3198 7.25102C52.3619 7.30716 52.4211 7.34813 52.4885 7.36778L53.3187 7.61005C53.3861 7.6297 53.4453 7.67067 53.4874 7.72681C53.5295 7.78295 53.5523 7.85123 53.5523 7.9214V8.2321C53.5523 8.31812 53.5181 8.40061 53.4573 8.46144C53.3964 8.52226 53.314 8.55643 53.2279 8.55643H52.9036M52.9036 6.61048H53.2279C53.314 6.61048 53.3964 6.64465 53.4573 6.70548C53.5181 6.7663 53.5523 6.84879 53.5523 6.93481V7.09697M52.9036 6.61048V5.96183M52.9036 8.55643H52.5793C52.4933 8.55643 52.4108 8.52226 52.35 8.46144C52.2891 8.40061 52.255 8.31812 52.255 8.2321V8.06994M52.9036 8.55643V9.20508M56.6333 5.06994V5.31319H49.1739V5.06994C50.7955 4.50238 51.7685 4.01589 52.8225 3.20508H52.9847C54.0387 4.01589 55.0117 4.50238 56.6333 5.06994Z",
    stroke: "white",
    strokeWidth: 0.454054
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.324324,
    y: 0.324324,
    width: 13.5449,
    height: 13.2223,
    rx: 6.61116,
    stroke: "white",
    strokeWidth: 0.648649
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2614_1235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1781 5.96183V9.20508M4.98886 5.96183V9.20508M4.01589 5.96183V9.20508M9.20508 5.96183V9.20508M3.85373 9.85373H10.3402M3.20508 10.6645H10.9889M7.09697 6.61048H6.77265C6.68663 6.61048 6.60414 6.64465 6.54331 6.70548C6.48249 6.7663 6.44832 6.84879 6.44832 6.93481V7.05643C6.44832 7.1266 6.47108 7.19488 6.51319 7.25102C6.55529 7.30716 6.61447 7.34813 6.68184 7.36778L7.51211 7.61005C7.57947 7.6297 7.63865 7.67067 7.68075 7.72681C7.72286 7.78295 7.74562 7.85123 7.74562 7.9214V8.2321C7.74562 8.31812 7.71145 8.40061 7.65063 8.46144C7.5898 8.52226 7.50731 8.55643 7.42129 8.55643H7.09697M7.09697 6.61048H7.42129C7.50731 6.61048 7.5898 6.64465 7.65063 6.70548C7.71145 6.7663 7.74562 6.84879 7.74562 6.93481V7.09697M7.09697 6.61048V5.96183M7.09697 8.55643H6.77265C6.68663 8.55643 6.60414 8.52226 6.54331 8.46144C6.48249 8.40061 6.44832 8.31812 6.44832 8.2321V8.06994M7.09697 8.55643V9.20508M10.8267 5.06994V5.31319H3.36724V5.06994C4.98886 4.50238 5.96184 4.01589 7.01589 3.20508H7.17805C8.23211 4.01589 9.20508 4.50238 10.8267 5.06994Z",
    stroke: "white",
    strokeWidth: 0.454054
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 39.166,
    width: 0.645161,
    height: 7.74194,
    transform: "rotate(-45 40 39.166)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.124,
    y: 18.377,
    width: 0.645161,
    height: 7.74194,
    transform: "rotate(135 20.124 18.377)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 0.645161,
    height: 7.74194,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 20.124 39.166)",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 0.645161,
    height: 7.74194,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 40 18.377)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2614_1235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.6452,
    height: 20.6452,
    fill: "white",
    transform: "translate(20 17.4199)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2614_1235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.78378,
    height: 7.45946,
    fill: "white",
    transform: "translate(49.0117 49.0117)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2614_1235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.78378,
    height: 7.45946,
    fill: "white",
    transform: "translate(3.20508 49.0117)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2614_1235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.78378,
    height: 7.45946,
    fill: "white",
    transform: "translate(49.0117 3.20508)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2614_1235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.78378,
    height: 7.45946,
    fill: "white",
    transform: "translate(3.20508 3.20508)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab3Icon);
export default __webpack_public_path__ + "static/media/tab3_icon.170cd3cbc36f3942a98d4547c885a35f.svg";
export { ForwardRef as ReactComponent };